import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify'; // Import toast
import 'react-toastify/dist/ReactToastify.css'; // Import toast styles
import { homePageBottomApi, edithomePageBottomApi } from 'Services/allApi'; // Import the edit API


function HomePageBottom() {
  const [formData, setFormData] = useState({
    head_sec_1: '',
    head_sec_2: '',
    head_sec_3: '',
    description: '',
    btn_content: '',
    btn_link: '',
  });

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [validationError, setValidationError] = useState('');

  // Fetch data on component mount
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await homePageBottomApi();
        console.log("response", response);
        const data = response.data;
        if (response.error) {
          setError(response.message);
        } else {
          setFormData({
            head_sec_1: data.head_sec_1 || '',
            head_sec_2: data.head_sec_2 || '',
            head_sec_3: data.head_sec_3 || '',
            description: data.description || '',
            btn_content: data.btn_content || '',
            btn_link: data.btn_link || '',
          });
        }
      } catch (err) {
        setError('Failed to fetch data. Please try again.');
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Validation function
  const validateForm = () => {
    let isValid = true;

    // Validate each section
    if (!formData.head_sec_1) {
      toast.error("Head Section 1 cannot be empty");
      isValid = false;
    }

    if (!formData.head_sec_2) {
      toast.error("Head Section 2 cannot be empty");
      isValid = false;
    }

    if (!formData.head_sec_3) {
      toast.error("Head Section 3 cannot be empty");
      isValid = false;
    }

    if (!formData.description) {
      toast.error("Description cannot be empty");
      isValid = false;
    }

    if (!formData.btn_content) {
      toast.error("Button Content cannot be empty");
      isValid = false;
    }

    if (!formData.btn_link) {
      toast.error("Button Link cannot be empty");
      isValid = false;
    }

    return isValid;
  };

  // Handle the update button
  const handleUpdate = async () => {
    const isValid = validateForm();
    if (isValid) {
      try {
        const response = await edithomePageBottomApi(1, formData); // Replace `1` with the actual id you want to use
        if (response.error) {
          toast.error("Failed to update. Please try again.");
        } else {
          toast.success("Home page bottom content updated successfully!");
        }
      } catch (error) {
        toast.error("Error updating home page bottom content.");
      }
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div className="max-w-6xl mx-auto p-6 bg-white shadow-lg rounded-lg mt-3  dark:!bg-navy-700 dark:text-white">
      <h2 className="text-center text-3xl font-bold mb-5 mt-2">Home Bottom</h2>
      <hr className="mb-4" />

      <div className="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-4 mt-5">
        {/* Head Section 1 */}
        <div className="sm:col-span-2">
          <label htmlFor="head_sec_1" className="block font-medium text-gray-900">Head Section 1</label>
          <div className="mt-2">
            <input
              type="text"
              name="head_sec_1"
              id="head_sec_1"
              value={formData.head_sec_1}
              onChange={handleInputChange}
              className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-purple-800 sm:text-sm/6  dark:!bg-navy-700 dark:text-white"
            />
          </div>
        </div>

        {/* Head Section 2 */}
        <div className="sm:col-span-2">
          <label htmlFor="head_sec_2" className="block font-medium text-gray-900">Head Section 2</label>
          <div className="mt-2">
            <input
              type="text"
              name="head_sec_2"
              id="head_sec_2"
              value={formData.head_sec_2}
              onChange={handleInputChange}
              className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-purple-800 sm:text-sm/6  dark:!bg-navy-700 dark:text-white"
            />
          </div>
        </div>

        {/* Head Section 3 */}
        <div className="sm:col-span-4">
          <label htmlFor="head_sec_3" className="block font-medium text-gray-900">Head Section 3</label>
          <div className="mt-2">
            <input
              type="text"
              name="head_sec_3"
              id="head_sec_3"
              value={formData.head_sec_3}
              onChange={handleInputChange}
              className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-purple-800 sm:text-sm/6  dark:!bg-navy-700 dark:text-white"
            />
          </div>
        </div>

        {/* Description */}
        <div className="sm:col-span-4">
          <label htmlFor="description" className="block font-medium text-gray-900">Description</label>
          <div className="mt-2">
            <textarea
              name="description"
              id="description"
              value={formData.description}
              onChange={handleInputChange}
              className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-purple-800 sm:text-sm/6  dark:!bg-navy-700 dark:text-white"
            />
          </div>
        </div>

        {/* Button Content */}
        <div className="sm:col-span-2">
          <label htmlFor="btn_content" className="block font-medium text-gray-900">Button Content</label>
          <div className="mt-2">
            <input
              type="text"
              name="btn_content"
              id="btn_content"
              value={formData.btn_content}
              onChange={handleInputChange}
              className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-purple-800 sm:text-sm/6  dark:!bg-navy-700 dark:text-white"
            />
          </div>
        </div>

        {/* Button Link */}
        <div className="sm:col-span-2">
          <label htmlFor="btn_link" className="block font-medium text-gray-900">Button Link</label>
          <div className="mt-2">
            <input
              type="text"
              name="btn_link"
              id="btn_link"
              value={formData.btn_link}
              onChange={handleInputChange}
              className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-purple-800 sm:text-sm/6  dark:!bg-navy-700 dark:text-white"
            />
          </div>
        </div>
        
      </div>
      <hr className="mt-5 mb-5" />

      {/* Update Button */}
      <div className="flex justify-center">
        <button
          type="button"
          onClick={handleUpdate}
          className="px-4 py-2 bg-purple-600 text-white rounded-md shadow hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-500"
        >
          Update
        </button>
      </div>
    </div>
  );
}

export default HomePageBottom;
